import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { DialogView } from "@/shared/components/molecules/DialogView";
import { Branch } from "@/app/branchs/branchs.type";
import { Option } from "@/shared/components/molecules/OptionsSelect";

type Errors = { nombre: string };
type LeadFormViewMoreProps = {
  handleSubmit: () => void;
  setToggleNewLeadModal: (open: boolean) => void;
  toggleNewLeadModal: boolean;
  formData: {
    nombre: string;
    date: string;
    correo: string;
    beneficios: string;
    time: string;
    men_utilization: number[];
    women_utilization: number[];
  };
  errors: Errors;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedOptionBranch: string;
  setSelectedOptionBranch: (option: string) => void;

  branchSelected: Option;
  setBranchSelected: (branch: Option) => void;

  optionsBranch: string[];
  dataprint: any;
  branches: Branch[];
};

const LeadFormViewMore: React.FC<LeadFormViewMoreProps> = ({
  handleSubmit,
  setToggleNewLeadModal,
  toggleNewLeadModal,
  dataprint,
  branches,
  branchSelected,
  setBranchSelected
}) => {

  const [rooms, setRooms] = useState([
    { local: "Sala 1" },
  ]);

  const OnOpenAddProduct = () => {
    setRooms([...rooms, { local: `Sala ${rooms.length + 1}` }]);
  }

  return (
    <DialogView
      OnclickCreate={handleSubmit}
      OnclickCancel={() => {
        setToggleNewLeadModal(false);
      }}
      tittleButtonCreate="Aceptar"
      tittleButtonCancel="Cancelar"
      open={toggleNewLeadModal}
      setOpen={setToggleNewLeadModal}
      tittle={"Detalle del objetivo de ocupación de actividades dirigidas"}
      subTittle={""}
      branches={branches}
      branchSelected={branchSelected}
      setBranchSelected={setBranchSelected}
      handleExport={() => {}}
    >
      <div className="mt-0 mx-2">
        <div className="space-y-12">
          <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
            <div className="grid max-w-6xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-3">
              <div className="col-span-full flex space-x-4">
                <table className="min-w-full divide-y divide-gray-300 bg-white">
                  <thead>
                    <tr>
                      <th className="p-4 text-left text-sm font-semibold text-gray-900">
                        {t("compliance.table_name")}
                      </th>
                      <th className="p-4 text-left text-sm font-semibold text-gray-900">
                        {t("compliance.table_time")}
                      </th>
                      <th className="p-4 text-left text-sm font-semibold text-gray-900">
                        {t("compliance.table_from")}
                      </th>
                      <th className="p-4 text-left text-sm font-semibold text-gray-900">
                        {t("compliance.table_to")}
                      </th>
                      <th className="p-4 text-left text-sm font-semibold text-gray-900">
                        {t("compliance.table_specialist")}
                      </th>
                      <th className="p-4 text-center text-sm font-semibold text-gray-900">
                        {t("compliance.average_rating")}
                      </th>
                      <th className="p-4 text-center text-sm font-semibold text-gray-900">
                        {t("compliance.table_percent")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataprint.map((data: any, index: number) => (
                      <tr key={index} className="bg-white">
                        <td className="p-4 text-sm font-medium text-gray-500">
                          {data.name}
                        </td>
                        <td className="p-4 text-sm font-medium text-gray-500">
                          <div className="flex gap-2">
                            <span>{data.inital_of_day}</span>
                            <span>({data.time_start},</span>
                            <span>{data.duration}min)</span>
                          </div>
                        </td>
                        <td className="px-4 text-sm font-medium text-gray-500">
                          {data.from}
                        </td>
                        <td className="px-4 text-sm font-medium text-gray-500">
                          {data.to}
                        </td>
                        <td className="px-4 text-sm font-medium text-gray-500">
                          {data.specialists}
                        </td>
                        <td className="px-4 text-center text-sm font-medium text-gray-500">
                          <div className="flex justify-center w-full">
                            <span
                              className="flex items-center justify-center h-12 w-12 text-white rounded-full"
                              style={{ background: data.color }}
                            >
                              {Number(data.average_rating).toFixed(0)}
                            </span>
                          </div>
                        </td>
                        <td className="px-4 text-center text-sm font-medium text-gray-500">
                          <div className="flex justify-center w-full">
                            <span
                              className="flex items-center justify-center h-12 w-12 text-white rounded-full"
                              style={{ background: data.color }}
                            >
                              {Number(data.total_attendance).toFixed(0)}%
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DialogView>
  );
};

export default LeadFormViewMore;
